import React from 'react';

function NotFound() {
  return <div>NOT FOUND PAGE</div>;
}

export default NotFound;
